export var mockGetDocumentDownloadDetails = {
    pdf_present: true,
    pdf_url: "http://localhost:3000/robots.txt",
    docx_present: false,
    docx_url: null
};
